/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


